import { gql } from "@apollo/client";export default gql`mutation createUser($object: user_insert_input = {}) {
  insert_user_one(object: $object, on_conflict: { constraint: user_pkey, update_columns: id }) {
    id
    name
    email
    role
  }
}
`;
